export class MyUrls{
    static  getBackend(){
        let host = window.location.host;
        if(host.includes('offis.de')){
            return 'https://emmie-backend.offis.de/';
        }else{
            return 'V1/';
        }
    }

    static  getFrontend(){
        let host = window.location.host;
        if(host.includes('offis.de')){
            return 'https://emmie.offis.de';
        }else{
            return 'V2/';
        }
    }

    static  getWearable(){
        let host = window.location.host;
        if(host.includes('offis.de')){
            return "https://emmie-backend.offis.de/rest/thryves";
        }else{
            return 'V1/rest/thryves';
        }
    }

    static getDataSync(){
        let host = window.location.host;
        if(host.includes('offis.de')){
            return 'https://emmie-backend.offis.de/rest/datasyncs';
        }else{
            return 'V1/rest/datasyncs';
        }
    }

    static  getSignifico(){
        let host = window.location.host;
        if(host.includes('offis.de')){
            return "https://emmie-backend.offis.de/rest/significos";
        }else{
            return 'V1/rest/significos';
        }
    }
}